var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 26C19.0117 26 17.5 27.5117 17.5 29.375C17.5 30.4367 17.9992 31.4352 18.85 32.075L34.15 43.55C34.9516 44.1477 36.0484 44.1477 36.85 43.55L40.8859 40.5266C42.5664 36.3219 46.4898 33.2633 51.1727 32.8063L52.15 32.075C53.0008 31.4352 53.5 30.4367 53.5 29.375C53.5 27.5117 51.9883 26 50.125 26H20.875V26ZM38.2 45.35C36.5969 46.5523 34.4031 46.5523 32.8 45.35L17.5 33.875V48.5C17.5 50.982 19.518 53 22 53H42.8266C41.0617 50.8625 40 48.1133 40 45.125C40 44.7313 40.0211 44.3445 40.0562 43.9578L38.2 45.35ZM62.5 45.125C62.5 39.5369 57.9631 35 52.375 35C46.7869 35 42.25 39.5369 42.25 45.125C42.25 50.7131 46.7869 55.25 52.375 55.25C57.9631 55.25 62.5 50.7131 62.5 45.125ZM57.107 42.0805C57.543 42.5164 57.543 43.2336 57.107 43.6695L52.0445 48.732C51.6086 49.168 50.8914 49.168 50.4555 48.732L47.643 45.9195C47.207 45.4836 47.207 44.7664 47.643 44.3305Cnan nan 48.7961 43.8945 49.232 44.3305L51.25 46.3484L55.518 42.0805C55.9539 41.6445 56.6711 41.6445 57.107 42.0805Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckMail);
export default __webpack_public_path__ + "static/media/ic_check_mail.756ea97ee2e4f7eb74446aa688047dd3.svg";
export { ForwardRef as ReactComponent };